export const identifiedSpeciesIsVirus = (identifiedSpecies) => {
    return identifiedSpecies.attributes.species.includes('virus');
};

export const formatSpeciesName = (species) => {
    if (!species) return '';

    const SPECIAL_SPECIES_NAMES = {
        'calcoaceticus/baumannii complex': 'baumannii complex'
    };
    const speciesParts = species.replace('[', '').split(' ');
    const firstInitial = speciesParts[0][0];
    const restOfName = speciesParts.slice(1).join(' ');
    
    return `${firstInitial}. ${SPECIAL_SPECIES_NAMES[restOfName] || restOfName}`;
};

export function sortByIdConfidence(identifiedSpecies) {
    /* Sorts given list of IdentifiedSpecies from most confident species ID to least.
    If KID species call ranks are available, returns list of species sorted by ascending
    KID species call rank. Otherwise (Illumina samples with no KID), returns list of species
    sorted by descending reads fraction agreeing megabases.
    */
        return (identifiedSpecies || [])
            .sort((a, b) => 
                (a.attributes.species_call_rank_by_kid_value !== null)
                ? a.attributes.species_call_rank_by_kid_value - b.attributes.species_call_rank_by_kid_value
                : b.attributes.reads_frac_agreeing_megabases - a.attributes.reads_frac_agreeing_megabases
            );
    }
